import request from '@/utils/request';


export function customerList(data) {
  return request({
    url: 'api/customer/list',
    method: 'post',
    data: data
  })
}

export function bannerList(data) {
  return request({
    url: 'api/banner/list',
    method: 'post',
    data: data
  })
}

export function questionList(data) {
  return request({
    url: 'api/question/list',
    method: 'post',
    data: data
  })
}

export function updateIsQuestion(data) {
  return request({
    url: 'api/user/updateIsQuestion',
    method: 'post',
    data: data
  })
}

export function loginAuth(data) {
  return request({
    url: 'api/passport/loginAuth',
    method: 'post',
    data: data
  })
}



export function help(data) {
  return request({
    url: 'api/help/content',
    method: 'post',
    data: data
  })
}
export function categoryList(data) {
  return request({
    url: 'api/category/list',
    method: 'post',
    data: data
  })
}


export function serviceAll(data) {
  return request({
    url: 'api/goods.service/all',
    method: 'post',
    data: data
  })
}


export function serviceAllByOrder(data) {
  return request({
    url: 'api/goods.service/allForByGoods',
    method: 'post',
    data: data
  })
}



export function getAreList(data) {
  return request({
    url: 'api/regionare/list',
    method: 'post',
    data: data
  })
}

export function getAreListIsP(data) {
  return request({
    url: 'api/regionare/listisp',
    method: 'post',
    data: data
  })
}

export function getAreListIsS(data) {
  return request({
    url: 'api/regionare/listiss',
    method: 'post',
    data: data
  })
}


export function getAreListIsT(data) {
  return request({
    url: 'api/regionare/listist',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/common.js